import React from 'react';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import { Main } from 'components/Main/Main';
import { ToastContainer } from 'components/shared/ToastContainer/ToastContainer';

// i18n
import './shared/i18next';
// All the CSS
import './styles/_main.scss';

// Required for Fat Zebra,
declare global {
    // tslint:disable-next-line:interface-name
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        PaymentSession: any;
        paymentHost: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attachEvent: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        FatZebra: any;
    }
}

export const App = () => {
    return (
        <RecoilRoot>
            <BrowserRouter>
                <Main/>
            </BrowserRouter>
        </RecoilRoot>
    );
};

ReactDOM.render(
    <React.StrictMode>
        <App/>
        <ToastContainer/>
    </React.StrictMode>,
    document.getElementById('app')
);
